import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mhbhbmkiadwcbvrdcwnk.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1oYmhibWtpYWR3Y2J2cmRjd25rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA5NDk2NDksImV4cCI6MjA3NjUyNTY0OX0.fcuczdFa7uSSet0vvzaOIDCpSxf8aOFUard3Ak6vVLM'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      students_2025_10_21_13_22: {
        Row: {
          id: string
          user_id: string
          name: string
          email: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          user_id: string
          name: string
          email: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          user_id?: string
          name?: string
          email?: string
          created_at?: string
          updated_at?: string
        }
      }
      lesson_progress_2025_10_21_13_22: {
        Row: {
          id: string
          student_id: string
          lesson_section: string
          progress_data: any
          completed: boolean
          score: number
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          student_id: string
          lesson_section: string
          progress_data?: any
          completed?: boolean
          score?: number
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          student_id?: string
          lesson_section?: string
          progress_data?: any
          completed?: boolean
          score?: number
          created_at?: string
          updated_at?: string
        }
      }
      quiz_results_2025_10_21_13_22: {
        Row: {
          id: string
          student_id: string
          quiz_type: string
          score: number
          total_questions: number
          time_taken: number | null
          answers: any
          created_at: string
        }
        Insert: {
          id?: string
          student_id: string
          quiz_type?: string
          score: number
          total_questions: number
          time_taken?: number | null
          answers?: any
          created_at?: string
        }
        Update: {
          id?: string
          student_id?: string
          quiz_type?: string
          score?: number
          total_questions?: number
          time_taken?: number | null
          answers?: any
          created_at?: string
        }
      }
    }
  }
}